var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 34C26.3888 34 34 26.3888 34 17C34 7.61116 26.3888 0 17 0C7.61116 0 0 7.61116 0 17C0 26.3888 7.61116 34 17 34Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4878 13.1463H11.6585V23.9268C11.6585 24.3667 11.8333 24.7886 12.1443 25.0996C12.4553 25.4106 12.8772 25.5854 13.3171 25.5854H21.6098C22.0496 25.5854 22.4715 25.4106 22.7825 25.0996C23.0936 24.7886 23.2683 24.3667 23.2683 23.9268V13.1463H12.4878ZM15.8049 23.0976H14.1463V15.6341H15.8049V23.0976ZM20.7805 23.0976H19.122V15.6341H20.7805V23.0976ZM21.293 10.6585L19.9512 9H14.9756L13.6339 10.6585H10V12.3171H24.9268V10.6585H21.293Z",
    fill: "#0E0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.fcb5a3287b8252fa1a67f26c366457bf.svg";
export { ForwardRef as ReactComponent };